export function resolveMapTrackingUsername(
  profileUsername: string | undefined,
  authUsername: string | undefined,
  selectedUsername?: string | undefined
): string | null {
  const fromProfile = typeof profileUsername === 'string' ? profileUsername.trim() : '';
  const fromSelected = typeof selectedUsername === 'string' ? selectedUsername.trim() : '';
  const fromAuth = typeof authUsername === 'string' ? authUsername.trim() : '';
  const resolved = fromProfile || fromSelected || fromAuth;
  return resolved || null;
}
